module.exports = function(gantt){
	gantt.$inject = function(module){
		return module(this.$services);
	};
};